import './WorkspacesDetailsData.css';
import React, { useEffect, useState } from 'react';
import { IoDocuments } from 'react-icons/io5';
import Swal from 'sweetalert2';

import { Button, Select, Tooltip } from 'antd';
import { IoMdAdd } from 'react-icons/io';
import { PiClipboardTextFill } from 'react-icons/pi';
import { MdOutlineDelete } from 'react-icons/md';
import { useNavigate, useParams } from 'react-router-dom';
import CardSkeleton from '../../../../Components/Skeleton/CardSkeloton';
import { workspaces_Support_Documents_ActionHandler } from '../../../../Redux/Actions/user/WorkspaceSupportingDocumentList';
import { workspaces_Support_Documents_OutputList_ActionHandler } from '../../../../Redux/Actions/user/WorkspaceSupportingDocumentList';
import { useDispatch, useSelector } from 'react-redux';
import { workpace_folder_deleteAPI } from '../../../../Redux/Apis/user/ApiConfig';
const SearchIcon = '/assets/SearchIcon.svg';
const dotIcon = '/assets/dot.svg';
const { Option } = Select;
const WorkspacesDetailsData = ({
    setViewDataOutWorkspace,
    workspaceSupportingDocumentOutputDetailsData,
    workspaceId,
    workspaceName,
    handleClick,
    handleClickOutPut,
    permissionsDetails,
}) => {
    let dispatch = useDispatch();
    let Navigate = useNavigate();
    const parms = useParams();
    const workspace_id = parms.id;
    const [searchValue, setSearchValue] = useState(null);
    const [deleteId, setDeleteId] = useState(false);
    const [searchValueOutput, setSearchValueOutput] = useState(null);
    const [itemSupportToggleState, setItemSupportToggleState] = useState({});
    const [itemTemplateToggleState, setItemTemplateToggleState] = useState({});
    const workspaceSupportingDocumentDetailsData = useSelector(
        (state) =>
            state?.workspaces_Supporting_Document_FolderList_Data
                ?.workspace_supporting_documentlist_data
    );
    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };
    const handleSearch = debounce((e) => {
        let value = e.target.value;

        let encodedValue = encodeURIComponent(value);

        if (encodedValue?.length) {
            setSearchValue(encodedValue);
        }

        if (!encodedValue.length) {
            dispatch(
                workspaces_Support_Documents_ActionHandler(workspaceId, '', '')
            );
        }
    }, 1000);
    const handleSearchOutput = debounce((e) => {
        let value = e.target.value;

        let encodedValue = encodeURIComponent(value);

        if (encodedValue?.length) {
            setSearchValueOutput(encodedValue);
        }

        if (!encodedValue.length) {
            dispatch(
                workspaces_Support_Documents_OutputList_ActionHandler(
                    workspaceId,
                    '',
                    ''
                )
            );
        }
    }, 1000);
    const tooltipStyles = {
        backgroundColor: 'white',
        color: 'black',
    };
    useEffect(() => {
        if (searchValue?.length > 3) {
            dispatch(
                workspaces_Support_Documents_ActionHandler(
                    workspaceId,
                    searchValue,
                    ''
                )
            );
        }
        if (searchValueOutput?.length > 3) {
            dispatch(
                workspaces_Support_Documents_OutputList_ActionHandler(
                    workspaceId,
                    searchValueOutput,
                    ''
                )
            );
        }
        // eslint-disable-next-line
    }, [searchValue, searchValueOutput]);
    const handleSortChange = (sortvalue) => {
        dispatch(
            workspaces_Support_Documents_ActionHandler(
                workspaceId,
                '',
                sortvalue
            )
        );
    };
    const handleSortChangeOutput = (sortvalue) => {
        dispatch(
            workspaces_Support_Documents_OutputList_ActionHandler(
                workspaceId,
                '',
                sortvalue
            )
        );
    };

    const handleEdit = (e, item, folderName) => {
        e.stopPropagation();
        let navigateObj = {
            id: item.id,
        };
        const queryParams = new URLSearchParams(navigateObj).toString();
        const queryParamsObject = Object.fromEntries(
            new URLSearchParams(queryParams)
        );
        Navigate(`/workspaces/createFolder/${queryParamsObject?.id}`, {
            state: {
                id: workspaceId,
                name: workspaceName,
                fromFolder: folderName,
            },
        });
    };

    const handleToggleActionBook = (e, itemId) => {
        e.stopPropagation();
        setItemSupportToggleState((prevToggleState) => ({
            [itemId]: !prevToggleState[itemId],
        }));
        setItemTemplateToggleState({});
    };

    const handleToggleTemplateActionBook = (e, itemId) => {
        e.stopPropagation();
        setItemTemplateToggleState((prevToggleState) => ({
            [itemId]: !prevToggleState[itemId],
        }));
        setItemSupportToggleState({});
    };

    const handleDelete = (e, Id) => {
        e.stopPropagation();
        setItemSupportToggleState({});
        setItemTemplateToggleState({});
        if (Id) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'You want to delete this Folder?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        position: 'centre',
                        icon: 'success',
                        title: 'Workspace folder has been deleted successfully',
                        showConfirmButton: false,
                        timer: 1000,
                    });
                    setDeleteId(true);
                    handleDeleteWorkspace(Id);
                    dispatch(
                        workspaces_Support_Documents_ActionHandler(
                            workspace_id,
                            '',
                            ''
                        )
                    );
                }
            });
        }
    };
    const handleDeleteWorkspace = async (folderId) => {
        try {
            await workpace_folder_deleteAPI(folderId);
            setItemSupportToggleState({});
            setItemTemplateToggleState({});
            // window.location.reload();
        } catch (err) {}
    };

    return (
        <div className='workspace-container'>
            <div className='workspace-details-actions-container'>
                <div className='detail-action-main-1'>
                    <h3>
                        <IoDocuments />
                        Supporting Documents (
                        {workspaceSupportingDocumentDetailsData?.data?.length ||
                            0}
                        )
                    </h3>
                    <div>
                        <Button
                            className='main-api'
                            onClick={() => {
                                Navigate('/workspaces/createFolder', {
                                    state: {
                                        id: workspaceId,
                                        name: workspaceName,
                                        fromFolder: 'dataSupporting',
                                    },
                                });

                                //gtm
                                window.dataLayer.push({
                                    event: 'Create New Folder',
                                    buttonName: 'Create New Folder',
                                    userId: JSON.parse(
                                        localStorage.getItem('userDetails')
                                    )?.id,
                                    clientId: JSON.parse(
                                        localStorage.getItem('userDetails')
                                    )?.client_id,
                                });
                            }}>
                            <IoMdAdd />
                            Create New Folder
                        </Button>
                    </div>
                </div>

                <div className='details-action-main-2'>
                    <div className='relative search-container'>
                        <input
                            type='text'
                            placeholder='Search Documents here...'
                            className='search-from-logs'
                            onChange={(e) => handleSearch(e)}
                        />
                        <img src={SearchIcon} alt='' className='search-icon' />
                    </div>
                    <div>
                        <Select
                            defaultValue='Sort By'
                            className='workspace-select-class-div'
                            onChange={handleSortChange}>
                            <Option value='name'> Name</Option>
                            <Option value='created_at'> Created At</Option>
                        </Select>
                    </div>
                </div>

                <div className='details-action-main-3'>
                    {workspaceSupportingDocumentDetailsData ? (
                        <div className='workspaceaction-grid-container'>
                            {workspaceSupportingDocumentDetailsData?.data?.map(
                                (item, index) => (
                                    <div
                                        key={`workspace-action-${index}`}
                                        className='workspace-tabel'
                                        onClick={() =>
                                            handleClick(
                                                true,
                                                item?.id,
                                                item?.name
                                            )
                                        }>
                                        <div className='workspace-text'>
                                            <div className='workspace-container-main'>
                                                <div className='workspace-div-third'>
                                                    <div className='workspace-top'></div>
                                                    <div className='workspace-head'>
                                                        <div className='workspace-div-icon'>
                                                            <span>
                                                                <b>Created: </b>
                                                                {item?.date}
                                                            </span>
                                                        </div>
                                                        <div className='workspace-div-dot2'>
                                                            <div
                                                                className='recent-div-action recent-div-action-container'
                                                                onClick={(e) =>
                                                                    handleToggleActionBook(
                                                                        e,
                                                                        item.id
                                                                    )
                                                                }>
                                                                <img
                                                                    src={
                                                                        dotIcon
                                                                    }
                                                                    alt='dot icon'
                                                                    className='vertical-img-logo'
                                                                    height={20}
                                                                    width={20}
                                                                />

                                                                <div
                                                                    className={`workspace-detail-dropup-form-content recent-form-header-availibility ${
                                                                        itemSupportToggleState[
                                                                            item
                                                                                .id
                                                                        ]
                                                                            ? 'recent-workspace-droup-down-avail-details'
                                                                            : ''
                                                                    }`}>
                                                                    <div
                                                                        className='form-header-text'
                                                                        onClick={(
                                                                            e
                                                                        ) => {
                                                                            handleEdit(
                                                                                e,
                                                                                item,
                                                                                'dataSupporting'
                                                                            );
                                                                        }}>
                                                                        <span className='form-header-notifications-text'>
                                                                            Edit
                                                                        </span>
                                                                    </div>
                                                                    <div className='form-separator-header'></div>
                                                                    <div
                                                                        className='form-header-text'
                                                                        onClick={(
                                                                            e
                                                                        ) =>
                                                                            handleDelete(
                                                                                e,
                                                                                item.id
                                                                            )
                                                                        }>
                                                                        <span className='form-header-notifications-text form-text-color'>
                                                                            Delete
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='workspace-div-info'>
                                                        <h1 className='workspace-text-h1'>
                                                            <Tooltip
                                                                title={
                                                                    item.name
                                                                }
                                                                style={
                                                                    tooltipStyles
                                                                }>
                                                                <span>
                                                                    {item.name}
                                                                </span>
                                                            </Tooltip>
                                                        </h1>
                                                        <p>
                                                            Total Documents
                                                            <b>
                                                                {' '}
                                                                {
                                                                    item?.total_quick_actions
                                                                }
                                                            </b>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    ) : (
                        <CardSkeleton data={5} classname={true} />
                    )}
                </div>
            </div>

            <div className='workspace-data-seprator'></div>

            <div className='workspace-details-actions-container'>
                <div className='detail-action-main-1'>
                    <h3>
                        <PiClipboardTextFill />
                        Output Templates (
                        {workspaceSupportingDocumentOutputDetailsData?.data
                            ?.length || 0}
                        )
                    </h3>
                    <div>
                        <Button
                            className='main-api'
                            onClick={() => {
                                Navigate('/workspaces/createFolder', {
                                    state: {
                                        id: workspaceId,
                                        name: workspaceName,
                                        fromFolder: 'dataTemplate',
                                    },
                                });

                                //gtm
                                window.dataLayer.push({
                                    event: 'Create New Folder',
                                    buttonName: 'Create New Folder',
                                    userId: JSON.parse(
                                        localStorage.getItem('userDetails')
                                    )?.id,
                                    clientId: JSON.parse(
                                        localStorage.getItem('userDetails')
                                    )?.client_id,
                                });
                            }}>
                            <IoMdAdd />
                            Create New Folder
                        </Button>
                    </div>
                </div>

                <div className='details-action-main-2'>
                    <div className='relative search-container'>
                        <input
                            type='text'
                            placeholder='Search templates here...'
                            className='search-from-logs'
                            onChange={(e) => handleSearchOutput(e)}
                        />
                        <img src={SearchIcon} alt='' className='search-icon' />
                    </div>
                    <div>
                        {/* <Select
              defaultValue="Sort By"
              className="workspace-select-class-div"
            >
              <Option value="jack">Jack</Option>
              <Option value="lucy">Lucy</Option>
              <Option value="disabled" disabled>
                Disabled
              </Option>
              <Option value="Yiminghe">yiminghe</Option>
            </Select> */}
                        <Select
                            defaultValue='Sort By'
                            className='workspace-select-class-div'
                            onChange={handleSortChangeOutput}>
                            <Option value='name'> Name</Option>
                            <Option value='created_at'> Created At</Option>
                        </Select>
                    </div>
                </div>

                <div className='details-action-main-3'>
                    {workspaceSupportingDocumentOutputDetailsData ? (
                        <div className='workspaceaction-grid-container'>
                            {workspaceSupportingDocumentOutputDetailsData?.data?.map(
                                (item, index) => (
                                    <div
                                        key={`workspace-data-${index}`}
                                        className='workspace-tabel'
                                        onClick={() =>
                                            handleClickOutPut(
                                                true,
                                                item?.id,
                                                item?.name
                                            )
                                        }>
                                        <div className='workspace-text'>
                                            <div className='workspace-container-main'>
                                                <div className='workspace-div-third'>
                                                    <div className='workspace-top'></div>
                                                    <div className='workspace-head'>
                                                        <div className='workspace-div-icon'>
                                                            <span>
                                                                <b>Created: </b>
                                                                {item.date}
                                                            </span>
                                                        </div>
                                                        <div className='workspace-div-dot2'>
                                                            <div
                                                                className='recent-div-action recent-div-action-container'
                                                                onClick={(e) =>
                                                                    handleToggleTemplateActionBook(
                                                                        e,
                                                                        item.id
                                                                    )
                                                                }>
                                                                <img
                                                                    src={
                                                                        dotIcon
                                                                    }
                                                                    alt='dotIcon'
                                                                    height={20}
                                                                    width={20}
                                                                />
                                                            </div>
                                                            <div
                                                                className={`workspace-detail-dropup-form-content recent-form-header-availibility ${
                                                                    itemTemplateToggleState[
                                                                        item.id
                                                                    ]
                                                                        ? 'recent-workspace-droup-down-avail-details'
                                                                        : ''
                                                                }`}>
                                                                <div
                                                                    className='form-header-text'
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        handleEdit(
                                                                            e,
                                                                            item,
                                                                            'dataTemplate'
                                                                        );
                                                                    }}>
                                                                    <span className='form-header-notifications-text'>
                                                                        Edit
                                                                    </span>
                                                                </div>
                                                                <div className='form-separator-header'></div>
                                                                <div
                                                                    className='form-header-text'
                                                                    onClick={(
                                                                        e
                                                                    ) =>
                                                                        handleDelete(
                                                                            e,
                                                                            item?.id
                                                                        )
                                                                    }>
                                                                    <span className='form-header-notifications-text form-text-color'>
                                                                        Delete
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='workspace-div-info'>
                                                        <h1 className='workspace-text-h1'>
                                                            <Tooltip
                                                                title={
                                                                    item.name
                                                                }
                                                                style={
                                                                    tooltipStyles
                                                                }>
                                                                {item.name}
                                                            </Tooltip>
                                                        </h1>
                                                        <p>
                                                            Total Documents
                                                            <b>
                                                                {' '}
                                                                {
                                                                    item.total_quick_actions
                                                                }
                                                            </b>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    ) : (
                        <CardSkeleton data={5} classname={true} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default WorkspacesDetailsData;
